import {Admission} from "~/queries";


export function humanizeAdmissionStatus(status: Admission["status"]) {
    const mapping = {
        "1": "На рассмотрении",
        "2": "На рассмотрении",
        "3": "На рассмотрении",
        "4": "На рассмотрении",
        "5": "Одобрен",
    }
    if (status < 0) {
        return "Отказано";
    }

    return mapping[status] || status
}


export function getAdmissionStatusColor(status: Admission["status"]) {
    const mapping = {
        "1": "#DA7C0F",
        "2": "#DA7C0F",
        "3": "#DA7C0F",
        "4": "#DA7C0F",
        "5": "#32A71F",
    }
    if (status < 0) {
        return "#E53328"
    }
    return mapping[status] || "#6E798C";
}


export function humanizeCarType(value: Admission["carType"]) {
    const mapping = {
        "0": "Легковой",
        "1": "Грузовой"
    }
    return mapping[value] || value
}

export type TFileType = `type/${string}`
export function humanizeFileType(value: TFileType): string {
    return value.substring(value.indexOf('/') + 1)
}
